import { render, staticRenderFns } from "./discountCoupon.vue?vue&type=template&id=6021ccd6&scoped=true"
import script from "./discountCoupon.vue?vue&type=script&lang=js"
export * from "./discountCoupon.vue?vue&type=script&lang=js"
import style0 from "./discountCoupon.vue?vue&type=style&index=0&id=6021ccd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6021ccd6",
  null
  
)

export default component.exports